import { Navigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userProfile } from "../../state/actions/accountActions";
import Header from "../../components/Header";
import { useEffect, useState } from "react";

const ALLOWED_ROLES = ["agent", "menadzer", "rukovodilac"];

const AgentProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dispatch(userProfile())
      .then(setUser)
      .finally(() => setIsLoading(false));
  }, [dispatch, location.pathname]);

  if (isLoading) {
    return null;
  }

  if (!user || !ALLOWED_ROLES.includes(user.role)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <>
      <Header />
      {children}
    </>
  );
};

export default AgentProtectedRoute;
